<div class="tab-content">
  <div id="districtapprovals" role="tabpanel" class="tab-pane active collapse show" >
        <spinner [id]="'approvecomp'" [show]='activeSpinner'></spinner>
      <div class="row">
          <div class="col-md-12">
              <div class="tab" role="tabpanel">
                  <ul class="nav nav-tabs" role="tablist" style="margin-top: 0px;">
                      <li role="presentation" class="nav-item pointer"><a style="margin: 0px;" class="nav-link" [ngClass]="{'active': activesidetab == 'addtheme'}" (click)="navtabclick('addtheme')" name="pendingapprovals" aria-selected="true">{{'dynamicIndicator.addthemeforadmin' | translate }}</a></li>
                      <li role="presentation" class="nav-item pointer"><a style="margin: 0px;" class="nav-link" [ngClass]="{'active': activesidetab == 'addindicator'}" (click)="navtabclick('addindicator')" name="history"  aria-selected="false" >{{'dynamicIndicator.addindicatorsforadmin' | translate }}</a></li>

                  </ul>
                  <div class="tab-content p-4" *ngIf="activesidetab == 'addtheme'">
                      <div class="col-md-12">
                        <div role="tabpanel" class="tab-pane fade active show" id="dpending">
                            <div class="row mt-10" >
                                  <div class="col-md-6">
                                      <span>{{'header.assesmentyear' | translate }}<span class="text-star">*</span></span>
                                  </div>
                                  <div class="col-md-6">
                                      <select [(ngModel)]="assessmentYear" class="form-control custom-selectbox">
                                          <option *ngFor="let year of yearDropDownList" value="{{year}}">{{year}}</option>
                                      </select>
                                  </div>
                              </div>
                              <div class="row mt-10" >
                                  <div class="col-md-6">
                                      <span>{{'tabledataforstates.selectstate' | translate }}<span class="text-star">*</span></span>
                                  </div>
                                  <div class="col-md-6">
                                      <!-- <ng-multiselect-dropdown [placeholder]="'ALL'" [data]="stateDropDownList" [(ngModel)]="themefilterlist['stateuuidlist']" [settings]="dropdownSettings" (onSelect)="onItemSelect($event)"
                                      (onSelectAll)="onSelectAll($event)" (onDeSelect)="onItemDeSelect($event)" (onDeSelectAll)="onItemDeSelectAll($event)">
                                      </ng-multiselect-dropdown> -->
                                      <select [(ngModel)]="selectedstate" class="form-control custom-selectbox">
                                        <option value="undefined">{{'tabledataforstates.all' | translate}}</option>
                                        <option *ngFor="let state of stateArrayList" value="{{state['uuid']}}">{{'tabledataforstates.' + state.name | translate}}</option>
                                        </select>
                                      <!-- <span style="color:red" [hidden]="validation[0]">Please select state </span> -->
                                  </div>
                              </div>
                              <div class="row mt-10" >
                                  <div class="col-md-6">
                                      <span>{{'dynamicIndicator.themename' | translate }}<span class="text-star">*</span></span>
                                  </div>
                                  <div class="col-md-1" style="margin-top: 12px;">{{themefilterlist['srno']}}. </div>
                                  <div class="col-md-5">
                                     <input type="text" placeholder="" [(ngModel)]="themefilterlist['themename']" class="input-style"
                                      style="width: 100%;" appAlphabetsOnly maxlength="60">
                                      <span style="color:red" [hidden]="validation[1]">Please enter theme name </span>
                                  </div>
                              </div>
                              <div class="row mt-10" >
                                  <div class="col-md-4" style="margin-left:135px;">
                                      <button type="button" [disabled]="!themefilterlist['themename']" (click)="addtheme()" class="btn btn-info">{{'dynamicIndicator.addthemeforadmin' | translate }}</button>
                                  </div>
                              </div>
                       
                        </div>
                      </div>
                      
                    </div>        
                        
                  <div class="tab-content" *ngIf="activesidetab == 'addindicator'">
                      <div class="col-md-12">
                        <div role="tabpanel" class="tab-pane fade active show" id="dpending">
                            <div class="row mt-10" >
                                <div class="col-md-6">
                                    <span>{{'header.assesmentyear' | translate }}</span>
                                </div>
                                <div class="col-md-6">
                                    <select [(ngModel)]="assessmentYear" class="form-control custom-selectbox">
                                        <option *ngFor="let year of yearDropDownList" value="{{year}}">{{year}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row mt-10" >
                                <div class="col-md-6">
                                    <span>{{'datasubmitlevel.selecttheme' | translate}}</span>
                                </div>
                                <div class="col-md-6">
                                    <select [(ngModel)]="indicatorfilterlist['themeid']" class="form-control custom-selectbox">
                                        <option value="null" [disabled]="true">{{'datasubmitlevel.selecttheme'| translate}}</option>
                                        <option *ngFor="let theme of themeList" value="{{theme.entityUUID}}">{{theme['label']}}</option>
                                    </select>
                                    <span style="color:red" [hidden]="validation[2]">Please select theme </span>
                                </div>
                            </div>
                            <!-- <div class="row mt-10" >
                                <div class="col-md-6">
                                    <span>{{'datasubmitlevel.datasubmit' | translate}}</span>
                                </div>
                                <div class="col-md-6">
                                    <select [(ngModel)]="datasubmitted" disabled="" (change)="dataSubmissionChange()" class="form-control custom-selectbox selectdis">
                                        <option value="districtwise" >{{'dataSubs.datadistlevel' | translate}}</option>
                                    </select>
                                    <span style="color:red" [hidden]="validation[3]">Please select State/District </span>
                                </div>
                            </div> -->
                            <div class="row mt-10" >
                                <div class="col-md-6">
                                    <span>{{'dynamicIndicator.indicatorserialnumber' | translate}}</span>
                                </div>
                                <div class="col-md-6">
                                    <input type="text" appFloatwithMinmax max="100" placeholder="" [(ngModel)]="indicatorfilterlist['serialnumber']"
                                     class="input-style" style="width: 100%;">
                                    <!-- <span style="color:red" [hidden]="validation[5]">Please enter indicator name </span> -->
                                </div>
                            </div>
                            <div class="row mt-10" >
                                <div class="col-md-6">
                                    <span>{{'dynamicIndicator.indicatorname' | translate}}</span>
                                </div>
                                <div class="col-md-6">
                                    <input type="text" placeholder="" [(ngModel)]="indicatorfilterlist['indicatorname']"
                                     class="input-style" style="width: 100%;" appAlphabetsOnly maxlength="60">
                                    <!-- <span style="color:red" [hidden]="validation[5]">Please enter indicator name </span> -->
                                </div>
                            </div>
                            
                            <div class="row mt-10" >
                                <div class="col-md-6">
                                    <span>{{'dynamicIndicator.inputtype' | translate}}</span>
                                </div>
                                <div class="col-md-6">
                                    {{'dynamicIndicator.number' | translate}}: &nbsp;<input type="radio" name="Indicator" [(ngModel)]="indicatorfilterlist['numberInput']" value="yes"><br>
                                    {{'dynamicIndicator.yes/no' | translate}}: &nbsp;<input type="radio" name="Indicator" [(ngModel)]="indicatorfilterlist['booleanInput']" value="no"><br>
                                </div>
                            </div>
                            <div class="row mt-10" >
                                    <div class="col-md-6">
                                        <span>{{'dynamicIndicator.haschild' | translate}}</span>
                                    </div>
                                    <div class="col-md-6">
                                        {{'dataSubs.yes' | translate}} : &nbsp;<input type="radio" name="haschild" [(ngModel)]="indicatorfilterlist['subindnumber']" value="yes" (change)="changeSubIndi(indicatorfilterlist['subindnumber'])"><br>
                                        <!-- {{'dataSubs.no' | translate}} : &nbsp;<input type="radio" name="haschild" [(ngModel)]="indicatorfilterlist['subindboolean']" value="no"><br> -->
                                        {{'dataSubs.no' | translate}} : &nbsp;<input type="radio" name="haschild" [(ngModel)]="indicatorfilterlist['subindnumber']" value="no" (change)="changeSubIndi(indicatorfilterlist['subindnumber'])"><br>

                                    </div>
                                </div>
                            <div class="row mt-10" >
                                <div class="col-md-6">
                                    <span> {{'dynamicIndicator.subindicatorserialnumber' | translate}}</span>
                                </div>
                                <div class="col-md-6">
                                    <input type="text" placeholder=""  class="input-style" [(ngModel)]="subIndicatorList[0]['serialNo']"
                                     style="width: 100%;"  onkeydown="return /[a-z, ]/i.test(event.key)" maxlength="1" [disabled]="indicatorfilterlist['subindnumber']== 'no'">
                                    <!-- <span style="color:red" [hidden]="validation[5]">Please enter indicator name </span> -->
                                </div>
                            </div>
                            <div class="row mt-10" >
                                    <div class="col-md-6">
                                        <span> {{'dynamicIndicator.subindicatorinputtype' | translate}}</span>
                                    </div>
                                    <div class="col-md-6">
                                        {{'dynamicIndicator.number' | translate}}&nbsp; <input  type="radio" name="ssIndicatorchild" [(ngModel)]="subIndicatorList[0]['inputType']" value="DOUBLE"
                                         [disabled]="indicatorfilterlist['subindnumber']== 'no'"><br>
                                        {{'dynamicIndicator.yes/no' | translate}}: &nbsp; <input  type="radio" name="ssIndicatorchild" [(ngModel)]="subIndicatorList[0]['inputType']" value="BOOLEAN"
                                         [disabled]="indicatorfilterlist['subindnumber']== 'no'"><br>
                                    </div>
                                </div>
                                <div class="row mt-10" >
                                    <div class="col-md-6">
                                        <span>{{'dynamicIndicator.selectcomputationtype' | translate}}<span class="text-star">*</span></span>
                                    </div>
                                    <div class="col-md-6">
                                        <select [(ngModel)]="indicatorfilterlist['computationid']" (change)="computationCode($event)" class="form-control custom-selectbox">
                                            <option value="null" [disabled]="true">{{'dynamicIndicator.selectcomputationtype' | translate}}</option>
                                            <option *ngFor="let item of selectionList" value="{{item}}">{{item}}</option>
                                        </select>
                                         <!-- <span style="color:red" [hidden]="validation[2]">Please select theme </span> -->
                                     </div>
                                 </div>
                            <div class="row mt-10">
                                <div class="col-md-6">
                                    <span>{{'dynamicIndicator.subindicatorname' | translate}}</span>
                                </div>
                                <div class="col-md-6" >
                                  <input type="text" placeholder=""  [(ngModel)]="subIndicatorList[0]['label']"
                                   class="input-style" style="width: 70%;" appAlphabetsOnly maxlength="60" [disabled]="indicatorfilterlist['subindnumber']== 'no'">
                                  <!-- <input *ngIf = "i>0" type="text" placeholder=""  [(ngModel)]="Value['serialNo']" class="input-style" style="width: 50%;">
                                  <input *ngIf = "i>0" type="radio" name="{{i}}" (change)="inputTypeSelect($event,i)" value="DOUBLE">
                                  <input *ngIf = "i>0" type="radio" name="{{i}}" (change)="inputTypeSelect($event,i)" value="BOOLEAN"> -->
                                    <span  style="margin-left: 20px;">
                                        <button [disabled] ="subIndicatorList[0]['label'] == ''" class="btn btn-sm btn-info" (click)= "addSubIndTextBox()"><i class="fa fa-plus"></i></button>
                                        <!-- <button *ngIf = "i>0" class="btn btn-sm btn-danger" (click)= "removeSubIndTextBox()"><i class="fa fa-minus"></i></button> -->
                                    </span>
                                    <span style="color:red" [hidden]="validation[5]">Please enter indicator name </span>
                                </div>
                            </div>

                            <div class="row mt-10"  *ngFor = "let Value of subIndicatorList;let i = index; let l = count;"  >
                                <div class="col-md-6" *ngIf = "i>0">
                                    <span>{{'dynamicIndicator.subindicatorname' | translate}}</span>
                                </div>
                                <div class="col-md-6 d-flex flex-row bd-highlight" >
                                  <input *ngIf = "i>0" type="text" [(ngModel)]="Value['label']" class="input-style mr-1" style="width: 30%;">
                                  <input *ngIf = "i>0" type="text" [(ngModel)]="Value['serialNo']" class="input-style mr-1" style="width: 30%;">
                                  <div class="mr-2 mt-2 ml-2" *ngIf = "i>0">
                                    <input *ngIf = "i>0" type="radio" name="{{i}}" (change)="inputTypeSelect($event,i)" value="DOUBLE">&nbsp;
                                    <label for="dewey">{{'dynamicIndicator.number' | translate}}</label>
                                  </div>
                                  <div class="mr-1 mt-2" *ngIf = "i>0">
                                    <input *ngIf = "i>0" type="radio" name="{{i}}" (change)="inputTypeSelect($event,i)" value="BOOLEAN">&nbsp;
                                    <label for="dewey">{{'dynamicIndicator.yes/no' | translate}}</label>
                                  </div>
                                  
                                    <span class="pt-2 ml-4" *ngIf = "i== l-1">
                                        <button *ngIf = "i>0" [disabled] ="Value['serialNo'] == '' && Value['label'] == ''" class="btn btn-sm btn-info" (click)= "addSubIndTextBox()"><i class="fa fa-plus"></i></button>
                                      <button *ngIf = "i>0" class="btn btn-sm btn-danger" (click)= "removeSubIndTextBox()"><i class="fa fa-minus"></i></button>
                                    </span>
                                    <span style="color:red" [hidden]="validation[5]">Please enter indicator name </span>
                                </div>
                            </div>
                            <div class="row mt-10" style="margin-left:400px;margin-right:400px;margin-bottom: 20px;">
                                <div class="col-md-4" style="margin-left:135px;">
                                    <button type="button" (click)="addtheme()" class="btn btn-info">{{'dynamicIndicator.addindicatorsforadmin' | translate }}</button>
                                </div>
                            </div> 
                        </div>
                      </div>
                    
                  </div>
                  
              </div>
          </div>
      </div>

  </div>
</div>